export default "__VITE_ASSET__BcqRaV$C__"